import segmentPlugin from '@analytics/segment'
import { Analytics } from 'analytics'

import {
  AnalyticsAction,
  AnalyticsActionType,
  AnalyticsPageAction,
  AnalyticsTrackAction,
} from 'types/common/analytics.type'
import { excludeFalsy, isString } from 'utils/common/common'

export const analytics = Analytics({
  app: 'tccc-master-of-taste',
  plugins: [
    segmentPlugin({
      writeKey: process.env.REACT_APP_SEGMENT_ANALYTICS_KEY,
    }),
  ].filter(excludeFalsy),
})

export const reset = () => {
  analytics.reset()
}

const getAnalyticsTenantAzId = () => analytics?.getState()?.user?.traits?.tenantAzId

const trackPage = ({ payload }: AnalyticsPageAction) => {
  const analyticsTenantAzId = getAnalyticsTenantAzId()
  if (analyticsTenantAzId) {
    analytics.page(
      {
        title: payload,
      },
      {
        agency: analyticsTenantAzId,
      },
    )
  }
}

const trackAction = ({ payload }: AnalyticsTrackAction) => {
  const analyticsTenantAzId = getAnalyticsTenantAzId()
  if (analyticsTenantAzId) {
    if (isString(payload)) {
      analytics.track(payload, {
        agency: analyticsTenantAzId,
      })
    } else {
      const { action, params } = payload

      analytics.track(action, {
        agency: analyticsTenantAzId,
        ...Object.fromEntries(params.map(({ key, value }) => [key, value])),
      })
    }
  }
}

export const trackAnalytics = (action: AnalyticsAction) => {
  switch (action.type) {
    case AnalyticsActionType.page:
      trackPage(action)
      break

    case AnalyticsActionType.action:
      trackAction(action)
      break

    default:
      break
  }
}

export const EVENTS = {
  PAGES: { PLAYGROUND_PP: 'pg_pv_persistentplatform' },
  ACTIONS: {
    PLAYGROUND_PP_HEADER_VIEWVIDEO: 'pg_act_persistentplatform_header_viewvideo',
    PLAYGROUND_PP_TEMPLATE: 'pg_act_persistentplatform_template',
    PLAYGROUND_PP_VIEWVIDEO: 'pg_act_persistentplatform_step_3_viewvideo',
    PLAYGROUND_PP_QUIZ: 'pg_act_persistentplatform_quiz',
    PLAYGROUND_PP_MURAL: 'pg_act_persistentplatform_mural',
    PLAYGROUND_PP_RESOURCES: 'pg_act_persistentplatform_tips_tricks_PPresources',
    PLAYGROUND_PP_LOOP: 'pg_act_persistentplatform_experience_loop_page',
  },
}
